<!-- 【通知详情】页面 -->
<template>
  <div class="front-body">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <sui-breadcrumb></sui-breadcrumb>
      </div>
      <div content="article">
        <h1 class="font-shadow article-title">{{works.name}}</h1>
        <span class="article-type" :style="dict.style" v-for="dict in worksTypeDict" :key="dict.dictValue">
          <span v-if="dict.dictValue==works.worksType">{{dict.dictLabel}}</span>
        </span>
        <div style="width: 1500px;margin: 0 auto;display: block;padding: 10px 0">
          <div v-html="works.introduce" style="white-space: pre-wrap;font-size: large;line-height:50px"></div>
          <span style="color: #e6a23c" class="el-icon-s-flag flag"></span>
          <el-tag style="margin-right: 5px" type="warning" v-for="tag in works.keyWord.split(',')" :key="tag">{{tag}}</el-tag>
          <div style="color: #e6a23c;font-size: medium;margin-top: 10px">点击图片可放大查看<i class="fa fa-hand-o-down" style="margin-left: 10px"></i></div>

        </div>
        <div id="file" style="margin: 0 auto;display: block;background: rgba(128,128,128,0.2);width: 1500px;padding: 30px;border-radius: 10px">
          <img @click="imgViewer(file)" v-for="file in works.fileList" class="article-image" :src="formatUrl(file)"/>
        </div>
      </div>
    </el-card>
    <el-backtop style="margin-bottom: 50px;margin-right: 270px" target=".front-page"></el-backtop>
  </div>
</template>

<script>
  //浏览器预览:支持txt和pdf
  import Viewer from 'viewerjs';
  import 'viewerjs/dist/viewer.css';
  export default {
    name: "works",
    data() {
      return {
        //表单数据
        works: {
          picture: "",
          title: "",
          worksType: "",
          publishTime: "",
          content: ""
        },
      }
    },
    mounted(){
      let params = this.$route.query;
      this.getWorks(params.id);
    },
    watch: {
      '$route.query.id'(id) {
        if(id){
          this.getWorks(id);
        }
      }
    },
    computed: {
      //【通知分类】
      worksTypeDict() {
        return this.$store.getters.getDictArray('works_type');
      },
    },
    methods: {
      //根据id获取数据
      getWorks(id) {
        this.$request.doGet("/api/works/get?id=" + id).then(res => {
          if (res.isOk) {
            this.works = res.obj;
          }
        });
      },
      //图片预览
      imgViewer(file){
        const that = this;
        that.$nextTick(function () {
          let viewer = new Viewer(document.getElementById('file'), {
            toolbar: {
              zoomIn: 0,
              zoomOut: 0,
              oneToOne: 0,
              reset: 0,
              prev: 1,
              play: 0,
              next: 1,
              // rotateLeft: 1,
              // rotateRight: 1,
              // flipHorizontal: 1,
              // flipVertical: 1,
            },
            keyboard: true,
            navbar: true,
            fullscreen: true,
            hide: function () { //在图片消失的时候销毁viewer
              viewer.destroy()
            },
          });
          viewer.view()
        })
      }
    }
  }
</script>
<style scoped>
  .box-card {
    padding-bottom: 20px;
    min-height: 1000px
  }

  .article-title {
    margin-top: 20px;
    text-align: center;
    display: block;
    font-weight: bold;
    font-size: x-large;
  }

  .article-type {
    font-size: 22px;
    display: block;
    font-size: small;
    margin-top: 20px;
    text-align: center;
    color: #999
  }

  .article-image {
    padding: 10px;
    border-radius: 10px;
    width: 480px;
    height:300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/service/works/worksDetails.vue